import { Typography } from '@mui/material';
import { styled } from '@mui/system';
import { VyIcon } from '@vy/ui-design-system';
import { type FC } from 'react';
import type { Control } from 'react-hook-form';
import { ControlledTextInput } from '../../../components/ControlledTextInput';
import type { SalesforceRegisterFormValues } from '../SalesforceRegisterFormSchema';

type SalesforceRegistrationFormProps = { control: Control<SalesforceRegisterFormValues> };

export const SalesforceRegistrationForm: FC<SalesforceRegistrationFormProps> = ({ control }) => (
  <FormContainer>
    <LogoContainer>
      <VyIcon
        icon="SalesforceLogoIcon"
        style={{
          transform: 'scale(0.5)',
          transformOrigin: 'top left',
        }}
      />
    </LogoContainer>
    <Typography variant="h4">Enter the following fields to get started</Typography>
    <ControlledTextInput name="accountUrl" control={control} label="Account URL" />
    <ControlledTextInput name="clientId" control={control} label="Client ID" />
    <ControlledTextInput name="clientSecret" control={control} label="Client Secret" />
  </FormContainer>
);

const FormContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
});

const LogoContainer = styled('div')({
  width: 100,
  height: 100,
});
